import type { FC } from "react";
import { Outlet, useMatches } from "react-router";

type ComponentMap = Record<string, React.ReactNode>;

export interface PanelOutletProps {
  components?: ComponentMap;
  fallback?: React.ReactNode;
}

export const PanelOutlet: FC<PanelOutletProps> = ({ components, fallback }) => {
  const matches = useMatches();

  if (!components) {
    return <Outlet />;
  }

  const matchedRoute = matches.find((match) => match.id && match.id in components);
  const Component = matchedRoute ? components[matchedRoute.id] : fallback;

  if (!Component) {
    return null;
  }

  return Component;
};
